const KAVA = ({ ...props }) => (
  <svg
    width="20"
    height="20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="10" cy="10" r="10" fill="#fff" />
    <path
      opacity=".2"
      d="M5.29 14.664 6.09 17l5.493-7-5.492-7-.84 2.285L8.9 9.999l-3.61 4.665Z"
      fill="#FF564F"
    />
    <path
      d="M16.998 16.999h-2.606l-5.494-7L14.392 3h2.606l-5.416 6.999 5.416 7Z"
      fill="#F08179"
    />
    <path
      d="M4 3h2.09v13.999H4V3ZM17 16.999h-2.606l-5.494-7L14.394 3H17l-5.416 6.999 5.416 7Z"
      fill="#FF564F"
    />
    <path
      d="M17 16.999h-2.606l-5.494-7L14.394 3H17l-5.416 6.999 5.416 7Z"
      fill="#FF564F"
    />
    <path
      d="M17 16.999h-2.606l-5.494-7L14.394 3H17l-5.416 6.999 5.416 7Z"
      fill="#FF564F"
    />
    <path
      d="M17 16.999h-2.606l-5.494-7L14.394 3H17l-5.416 6.999 5.416 7Z"
      fill="#FF564F"
    />
  </svg>
);
export default KAVA;
